import React, { useState } from "react";
import api from "../../lib/api";
import { Button } from "../../components/ui/button";
import { Textarea } from "../../components/ui/textarea";
import { Send, Sparkles } from "lucide-react";

const STARTERS = [
  "Quali sono i KPI principali questo mese?",
  "Dove possiamo migliorare il margine?",
  "Quali leads hanno priorità alta?",
];

export default function AdminAnalyst() {
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState("");
  const [session, setSession] = useState(null);
  const [loading, setLoading] = useState(false);

  const send = async (text) => {
    const msg = (text ?? input).trim();
    if (!msg) return;
    setMessages(prev => [...prev, { role: "user", text: msg }]);
    setInput("");
    setLoading(true);
    try {
      const r = await api.post("/admin/analyst", { message: msg, session_id: session });
      setSession(r.data.session_id);
      setMessages(prev => [...prev, { role: "assistant", text: r.data.answer, kpis: r.data.kpis }]);
    } catch { setMessages(prev => [...prev, { role: "assistant", text: "Errore AI" }]); } finally { setLoading(false); }
  };

  return (
    <div data-testid="admin-analyst-page" className="flex flex-col h-[calc(100vh-3rem)]">
      <div>
        <div className="text-xs uppercase tracking-[0.3em] text-[hsl(var(--primary))] font-semibold flex items-center gap-2"><Sparkles className="h-3 w-3"/>AI Business Analyst · GPT-5.2</div>
        <h1 className="editorial-heading text-4xl mt-1">Chiedi ai tuoi dati</h1>
      </div>
      <div className="mt-6 flex-1 overflow-y-auto bg-card border border-border rounded-sm p-5 space-y-4">
        {messages.length === 0 && (
          <div className="text-muted-foreground">
            <div className="mb-3 text-sm">Domande di esempio:</div>
            <div className="flex flex-wrap gap-2">
              {STARTERS.map((s, i) => (
                <button key={i} data-testid={`analyst-starter-${i}`} onClick={() => send(s)} className="text-left text-sm border border-[hsl(var(--primary))]/40 text-[hsl(var(--primary))] px-3 py-2 rounded-sm hover:bg-[hsl(var(--primary))]/10">{s}</button>
              ))}
            </div>
          </div>
        )}
        {messages.map((m, i) => (
          <div key={i} data-testid={`analyst-msg-${i}`} className={`max-w-[85%] ${m.role === "user" ? "ml-auto bg-[hsl(var(--primary))] text-white" : "bg-[hsl(var(--muted))] border border-border"} p-4 rounded-sm`}>
            <div className="text-[10px] uppercase tracking-wider opacity-70 mb-1">{m.role === "user" ? "Tu" : "AI Analyst"}</div>
            <div className="whitespace-pre-wrap text-sm leading-relaxed">{m.text}</div>
          </div>
        ))}
        {loading && <div className="text-sm text-muted-foreground italic">Analisi dei dati…</div>}
      </div>
      <div className="mt-4 flex gap-2">
        <Textarea data-testid="analyst-input" rows={2} value={input} onChange={e => setInput(e.target.value)} onKeyDown={e => { if (e.key === "Enter" && !e.shiftKey) { e.preventDefault(); send(); } }} placeholder="Es: Quali vini hanno margine migliore?" className="flex-1 rounded-sm" />
        <Button data-testid="analyst-send" onClick={() => send()} disabled={loading} className="bg-[hsl(var(--primary))] text-white hover:bg-[hsl(var(--primary))]/90 rounded-sm gap-2"><Send className="h-4 w-4"/>Invia</Button>
      </div>
    </div>
  );
}
